import {
  ConfirmationDialog,
  ConfirmationDialogProps,
} from './ConfirmationDialog';
import { ConfirmationDialogResult } from './types';
import { makeDialog } from '../../makeDialog';

export const useConfirmationDialog = makeDialog<
  ConfirmationDialogProps,
  ConfirmationDialogResult
>(ConfirmationDialog);
